var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaseStudy4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M24 30L18 24M24 30C26.7937 28.9375 29.4738 27.5975 32 26M24 30V40C24 40 30.06 38.9 32 36C34.16 32.76 32 26 32 26M18 24C19.0643 21.2389 20.4044 18.5921 22 16.1C24.3304 12.374 27.5752 9.30611 31.426 7.18819C35.2768 5.07028 39.6053 3.97275 44 4.00001C44 9.44001 42.44 19 32 26M18 24H8C8 24 9.1 17.94 12 16C15.24 13.84 22 16 22 16M9 33C6 35.52 5 43 5 43C5 43 12.48 42 15 39C16.42 37.32 16.4 34.74 14.82 33.18C14.0426 32.438 13.0186 32.0093 11.9445 31.9761C10.8703 31.9428 9.82175 32.3075 9 33Z",
    stroke: "#EE4540",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseStudy4);
export default __webpack_public_path__ + "static/media/caseStudy4.8141d595bab2d6c55c8d852ae77be3c4.svg";
export { ForwardRef as ReactComponent };